import { gql } from '@apollo/client';

export const CREATE_ANALYSIS_MUTATION = gql`
    mutation createAnalysis($input: StoryAnalysisInput!) {
        createAnalysis(input: $input) {
            storyId
            draftId
            published
            sources
            analysis {
                version
                storyAnalyzer {
                    analysis_metadata {
                        analyzer_version
                        plugins_used
                        processing_time
                        story_length
                        timestamp
                        word_count
                    }
                    interpretations {
                        flags
                        key_findings
                        overall_quality
                        recommendations
                    }
                    metadata {
                        analysis_time
                        plugins_used
                        text_length
                    }
                    overall_score
                    plugin_results {
                        advanced_readability {
                            automated_readability_index
                            average_readability
                            coleman_liau_index
                            contribution_to_overall
                            flesch_kincaid_grade
                            flesch_reading_ease
                            gunning_fog_index
                            is_accessible
                            reading_level
                        }
                        ai_detection {
                            ai_probability
                            confidence
                            contribution_to_overall
                            human_probability
                            is_likely_ai
                            original_length
                            processed_length
                            text_truncated
                        }
                        credibility_assessment {
                            consistency_score
                            contribution_to_overall
                            credibility_score
                            is_credible
                            negative_indicators
                            positive_indicators
                            source_quality
                            specificity_score
                        }
                        emotional_manipulation {
                            contribution_to_overall
                            emotional_intensity
                            is_manipulative
                            manipulation_breakdown {
                                emotional_blackmail
                                false_scarcity
                                false_urgency
                                fear_mongering
                            }
                            manipulation_score
                            original_length
                            primary_emotion
                            processed_length
                            text_truncated
                        }
                        misinformation_detection {
                            contribution_to_overall
                            fact_claims_detected
                            misinformation_risk
                            needs_fact_checking
                            risk_level
                            warning_phrases_found
                        }
                        openai_enhancement {
                            contribution_to_overall
                            cost_estimate
                            enhanced_sentiment {
                                confidence
                                emotional_tone
                                explanation
                                sentiment
                            }
                            quality_assessment {
                                confidence
                                engagement_level
                                quality_score
                                strengths
                                weaknesses
                            }
                            text_length
                        }
                        quality_metrics {
                            avg_word_length
                            contribution_to_overall
                            grammar_score
                            paragraph_count
                            readability_score
                            sentence_count
                            spelling_errors
                            word_count
                        }
                        sentiment {
                            confidence
                            contribution_to_overall
                            original_length
                            primary_sentiment
                            processed_length
                            scores {
                                negative
                                neutral
                                positive
                            }
                            text_truncated
                        }
                        topic_relevance {
                            category_scores {
                                economics
                                environment
                                health
                                personal
                                politics
                                social_issues
                                technology
                            }
                            contribution_to_overall
                            is_controversial
                            primary_topic
                            topic_confidence
                        }
                        emotion_detection {
                            emotion_scores {
                                joy
                                anger
                                fear
                                sadness
                                surprise
                                disgust
                                trust
                                anticipation
                            }
                            primary_emotion
                            secondary_emotion
                            emotional_intensity
                            emotional_state
                        }
                        story_summary {
                            character_count
                            contribution_to_overall
                            cost_estimate
                            key_topics
                            summary
                            summary_type
                            tone_description
                            word_count
                        }
                        self_harm {
                            category
                            blocks_publish
                        }
                    }
                    user_recommendations
                }
                sentiment {
                    confidence_explanation
                    contribution_explanation
                    sentiment_summary
                    text_analysis {
                        analysis_source
                        original_length
                        processed_length
                        text_truncated
                        truncation_reason
                    }
                    label
                    score
                    sentiment_scores {
                        negative
                        positive
                        neutral
                    }
                }
                createdAt
                updatedAt
            }
            createdAt
            updatedAt
        }
    }
`;
